module.exports = __webpack_public_path__ + "static/media/mw.290d49f1.svg";